module.exports = __webpack_public_path__ + "img/hybrid-image-1.0ad90080.png";